import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CatalogDetailComponent} from './catalog-detail/catalog-detail.component';
import {CatalogIndexComponent} from './catalog-index/catalog-index.component';
import {CatalogListComponent} from './catalog-list/catalog-list.component';
import {ModelDetailComponent} from './model-detail/model-detail.component';
import {SearchComponent} from './search/search.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import {ComponentsModule} from '../components/components.module';
import {ModelConfigurationComponent} from './model-configuration/model-configuration.component';
import {MatTabsModule} from '@angular/material/tabs';
import {TranslateModule} from '@ngx-translate/core';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatNativeDateModule, MatOptionModule} from '@angular/material/core';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {ModelDetailGridComponent} from '@page/model-detail-grid/model-detail-grid.component';
import {ModelDetailListComponent} from './model-detail-list/model-detail-list.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {UserAreaComponent} from './user-area/user-area.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import '../shared/utils/user-permission/all-user-permission';
import {SalesPolicyDisclaimerComponent} from './sales-policy-disclaimer/sales-policy-disclaimer.component';
import {RoutingByCodeComponent} from './routing-by-code/routing-by-code.component';
import {SearchSidenavComponent} from './search-sidenav/search-sidenav.component';
import {
  RegistrationPreactivationCodeComponent
} from './registration-preactivation-code/registration-preactivation-code.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {FreeSignupComponent} from './free-signup/free-signup.component';
import {CrmRoutingModule} from '../crm/crm-routing.module';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {ImageSwiperComponent} from '../components/swiper/swiper.component';
import {ComposerCardComponent} from "@app/model-composer/components/composer-card.component";
import {VisionnaireLoaderComponent} from "@app/model-composer/components/visionnaire-loader.component";

@NgModule({
  declarations: [
    CatalogDetailComponent,
    CatalogIndexComponent,
    CatalogListComponent,
    ModelDetailGridComponent,
    ModelDetailComponent,
    ModelConfigurationComponent,
    SearchComponent,
    ModelDetailListComponent,
    UserAreaComponent,
    SalesPolicyDisclaimerComponent,
    RoutingByCodeComponent,
    SearchSidenavComponent,
    RegistrationPreactivationCodeComponent,
    FreeSignupComponent
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    MatSidenavModule,
    MatTabsModule,
    TranslateModule,
    ScrollingModule,
    NgbModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatSlideToggleModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatOptionModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatCheckboxModule,
    CrmRoutingModule,
    MatProgressBarModule,
    ImageSwiperComponent,
    ComposerCardComponent,
    VisionnaireLoaderComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PagesModule {
}
